import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

export default function Sidebar({
  R1,
  R2,
  R3,
  R4,
  R6,
  R7,
  R8,
  R9,
  R10,
  R11,
  R12,
  R13,
  R14,
  R15,
  R16,
  I1,
  I2,
  I3,
  I4,
  I6,
  I7,
  I8,
  I9,
  I10,
  I11,
  I12,
  I13,
  I14,
  I15,
  I16,
  P1,
  P2,
  P3,
  P4,
  P6,
  P7,
  P8,
  P9,
  P10,
  P11,
  P12,
  P13,
  P14,
  P15,
  P16,
  Ac1,
  Ac2,
  Ac3,
  Ac4,
  Ac6,
  Ac7,
  Ac8,
  Ac9,
  Ac10,
  Ac11,
  Ac12,
  Ac13,
  Ac14,
  Ac15,
  Ac16,

  f3,
  DR,
}) {
  const role = localStorage.getItem('role');
  const [isOpen, setIsOpen] = useState(DR);
  const contentRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <Link to={R1} className={`nav-link ${Ac1 ? 'active' : 'collapsed'}`}>
            <i className={I1}></i>
            <span>{P1}</span>
          </Link>
        </li>

        {role === 'ADMIN' ? (
          <li className="nav-item">
            <div
              className={`nav-link ${isOpen ? '' : 'collapsed'}`}
              onClick={toggleDropdown}
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <span>
                <i className="bi bi-journal-text"></i>
                <span style={{ marginLeft: '8px' }}>Master</span>
              </span>
              <i
                className="bi bi-chevron-down ms-auto chevron-icon"
                style={{
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              ></i>
            </div>

            <ul
              ref={contentRef}
              className={`nav-content submenu p-0 ${isOpen ? 'open' : ''}`}
            >
              <li>
                <Link
                  to={R14}
                  className={`nav-link ${Ac14 ? 'active' : 'collapsed'}`}
                >
                  <i className={I14}></i>
                  <span>{P14}</span>
                </Link>
              </li>
              <li>
                <Link
                  to={R2}
                  className={`nav-link ${Ac2 ? 'active' : 'collapsed'}`}
                >
                  <i className={I2}></i>
                  <span>{P2}</span>
                </Link>
              </li>
              <li>
                <Link
                  to={R16}
                  className={`nav-link ${Ac16 ? 'active' : 'collapsed'}`}
                >
                  <i className={I16}></i>
                  <span>{P16}</span>
                </Link>
              </li>
              <li>
                <Link
                  to={R15}
                  className={`nav-link ${Ac15 ? 'active' : 'collapsed'}`}
                >
                  <i className={I15}></i>
                  <span>{P15}</span>
                </Link>
              </li>
            </ul>
          </li>
        ) : (
          <li className="nav-item">
            <Link
              to={R2}
              className={`nav-link ${Ac2 ? 'active' : 'collapsed'}`}
            >
              <i className={I2}></i>
              <span>{P2}</span>
            </Link>
          </li>
        )}

        {/* Remaining Links */}
        <li className="nav-item">
          <Link
            to={R3}
            onClick={f3}
            className={`nav-link ${Ac3 ? 'active' : 'collapsed'}`}
          >
            <i className={I3}></i>
            <span>{P3}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link to={R4} className={`nav-link ${Ac4 ? 'active' : 'collapsed'}`}>
            <i className={I4}></i>
            <span>{P4}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link to={R6} className={`nav-link ${Ac6 ? 'active' : 'collapsed'}`}>
            <i className={I6}></i>
            <span>{P6}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link to={R7} className={`nav-link ${Ac7 ? 'active' : 'collapsed'}`}>
            <i className={I7}></i>
            <span>{P7}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link to={R8} className={`nav-link ${Ac8 ? 'active' : 'collapsed'}`}>
            <i className={I8}></i>
            <span>{P8}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link to={R9} className={`nav-link ${Ac9 ? 'active' : 'collapsed'}`}>
            <i className={I9}></i>
            <span>{P9}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to={R10}
            className={`nav-link ${Ac10 ? 'active' : 'collapsed'}`}
          >
            <i className={I10}></i>
            <span>{P10}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to={R11}
            className={`nav-link ${Ac11 ? 'active' : 'collapsed'}`}
          >
            <i className={I11}></i>
            <span>{P11}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to={R12}
            className={`nav-link ${Ac12 ? 'active' : 'collapsed'}`}
          >
            <i className={I12}></i>
            <span>{P12}</span>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to={R13}
            className={`nav-link ${Ac13 ? 'active' : 'collapsed'}`}
          >
            <i className={I13}></i>
            <span>{P13}</span>
          </Link>
        </li>
      </ul>
    </aside>
  );
}
